
import { defineComponent, ref, onMounted, watch } from 'vue';
import { message, Modal } from 'ant-design-vue';
import { reactive } from 'vue';
import {
  query_card_record_extend_record_list,
  extend_card_record_end_date,
} from '@/api/mjstore-model';
import { notification } from 'ant-design-vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import moment from 'moment';
import { event_obj } from '@/components/page-model/mjstore/mjstore-orderrecord-config';
import { useForm } from 'ant-design-vue/es/form';

export default defineComponent({
  name: 'ExtendCardRecordModel',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    obj: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
    const loading = ref(false);
    const formModel: any = reactive({
      new_end_date: null,
      ...props.obj,
    });
    const modifyModal = {
      title: '',
      form: {
        settings: {
          labelAlign: 'right',
          layout: 'horizontal',
          labelCol: {
            span: 6,
          },
          wrapperCol: {
            span: 18,
          },
        },
        fields: [
          {
            type: 'datepicker',
            name: 'end_date',
            label: '原到期时间',
            disabled: true,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            format: 'YYYY-MM-DD',
            valueFormat: 'YYYY-MM-DD',
            showTime: true,
            placeholder: '请选择原到期时间',
          },
          {
            type: 'datepicker',
            name: 'new_end_date',
            label: '新到期时间',
            disabled: false,
            allowClear: true,
            format: 'YYYY-MM-DD',
            valueFormat: 'YYYY-MM-DD',
            showTime: false,
            placeholder: '请选择新到期时间',
          },
          {
            type: 'textarea',
            name: 'reason',
            label: '延期原因',
            disabled: false,
            allowClear: true,
            inputType: 'text',
            maxlength: 300,
            defaultValue: '',
            placeholder: '请填写延期原因',
          },
          {
            type: 'remoteselect',
            name: 'staff_id',
            label: '执行人',
            disabled: false,
            placeholder: '请选择执行人',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            init_model: { shop_id: current_shop?.id },
            modalType: 'mjstore-staff',
          },
        ],
        rules: {
          new_end_date: [{ required: true, message: '请选择新到期时间' }],
          reason: [{ required: true, message: '请填写延期原因' }],
        },
        model: formModel,
      },
      validateInfos: {},
      options: {},
    };
    const { validateInfos } = useForm(modifyModal.form.model, modifyModal.form.rules);
    modifyModal.validateInfos = validateInfos;
    const ExtendCardDataSource: Array<any> = reactive([]);
    const state = {
      ExtendCard: {
        columns: [
          {
            title: '原到期时间',
            dataIndex: 'old_date',
            key: 'old_date',
            width: 150,
          },
          {
            title: '新到期时间',
            dataIndex: 'new_date',
            key: 'new_date',
            width: 150,
          },
          {
            title: '延期原因',
            dataIndex: 'reason',
            key: 'reason',
            width: 150,
          },
          {
            title: '执行人',
            dataIndex: 'staff__name',
            key: 'staff__name',
            width: 150,
          },
        ],
        dataSource: ExtendCardDataSource,
      },
    };
    onMounted(() => {
      loadData();
    });

    const loadData = () => {
      query_card_record_extend_record_list({
        org_id: current_org?.id,
        card_record_id: props.obj.id,
      }).then((res: any) => {
        ExtendCardDataSource.length = 0;
        res.data.map((item: any) => {
          ExtendCardDataSource.push(item);
        });
        message.success('查询成功');
      });
    };

    const handleCancel = () => {
      emit('cancel');
    };

    const handleOk = () => {
      extend_card_record_end_date({
        org_id: current_org?.id,
        card_record_id: formModel.id,
        new_end_date: formModel.new_end_date,
        reason: formModel.reason,
        staff_id: formModel.staff_id,
      })
        .then(() => {
          notification.success({
            message: '成功',
            description: '延期成功',
          });
          emit('ok');
        })
        .finally(() => {
          loading.value = false;
        });
    };
    return {
      // fullscreen
      message,
      // edit
      loading,
      state,
      modifyModal,
      handleCancel,
      handleOk,
    };
  },
});
